module.exports = __webpack_public_path__ + "assets/SBSansUI-Light.84f3c489d9f922259d0fa2f9b75f73bcbe3841ac23c99e0b44491107bc2e533c.ttf";